// initial state
const state = {
  formSubmissionInfo: null
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setFormSubmissionInfo(state, formSubmissionInfo) {
    state.formSubmissionInfo = formSubmissionInfo;
  },
  setFormSubmission(state, formSubmission) {
    if (!state.formSubmissionInfo) {
			return;
		}
		state.formSubmissionInfo.formSubmission = formSubmission;
  },
	updateFormDefinition(state, formDefinition) {
		if (!state.formSubmissionInfo) {
			return;
		}
		state.formSubmissionInfo.form.definition = formDefinition;
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}